import { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { selectUploadProgressEntries } from '@/store/selectors/poc/uploadProgressSelectors';
import { clearUploadProgress } from '@/store/slices/poc/heliaSlice';

export function useSixDetailUploadProgress(sixId: string) {
  const dispatch = useAppDispatch();
  const allUploadProgressEntries = useAppSelector(selectUploadProgressEntries);

  const inFlightUploads = useMemo(
    () => allUploadProgressEntries.filter((entry) => entry.sixId === sixId),
    [allUploadProgressEntries, sixId],
  );

  const handleUploadProgressComplete = useCallback((uploadId: string): void => {
    dispatch(clearUploadProgress(uploadId));
  }, [dispatch]);

  return {
    state: {
      inFlightUploads,
    },
    handlers: {
      handleUploadProgressComplete,
    },
  };
}
